import CalendarTheme from "css/themes/calendar/calendar.css";
import React from "react";
import Calendar from "./Calendar";
import PartnerList from "./PartnerList";
import TaskList from "./TaskList";

class CalendarPageContainer extends React.Component {
  render() {
    return (
      <div className={CalendarTheme.calendarCampaignPage}>
        <PartnerList />
        <Calendar />
        <TaskList />
      </div>
    );
  }
}

export default CalendarPageContainer;
